import { render, staticRenderFns } from "./CharacteristicsForm.vue?vue&type=template&id=0bdc28cc&"
import script from "./CharacteristicsForm.vue?vue&type=script&lang=js&"
export * from "./CharacteristicsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports